import { GameRandom, ModelEvents } from '@denishussar/html5-game-engine';
import { Inject, Singleton } from '@denishussar/html5-game-engine';

export enum ColorRopesEnum {
    red,
    yellow,
    green,
}
@Singleton
export class RopesModel {
    public color = [];

    public rightAnswers: number = 0;
    public wrongAnswers: number = 0;
    public roundIndex: number = 0;
    public doneCounter: number = 0;
    public posInArray: number = 0;
    public rightOrderColors = ['red', 'yellow', 'green'];
    constructor() {
        this.clear();
    }

    public clear() {
        for (let i = 0; i < 3; i++) {
            this.color[i] = ColorRopesEnum[i];
        }
        for (let i = 0; i < 3; i++) {
            this.color[i+3] = ColorRopesEnum[2-i];
        }
        this.rightAnswers = 0;
        this.wrongAnswers = 0;
        this.roundIndex = 0;
        this.posInArray = 0;
        this.doneCounter = 0;
        this.rightOrderColors = ['red', 'yellow', 'green'];
    }
}
